// client/src/api/indexedFileAPI.js

import axiosInstance from '../utilities/axiosInstance';

const indexedFileAPI = {

  reindexContent: async (force = false) => {
    try {
      const response = await axiosInstance.post('/api/indexedFile/reindex', { force });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Reindex failed: ${error.message}` };
    }
  },

  getIndexStatus: async () => {
    try {
      const response = await axiosInstance.get('/api/indexedFile/status');
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to get status: ${error.message}` };
    }
  },
   
  reindexCourses: async () => {
    try {
      const response = await axiosInstance.post('/api/indexedFile/reindex-courses');
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Course reindex failed: ${error.message}` };
    }
  },

};

export default indexedFileAPI;